// Géneros, con los códigos que espera `usuarioSexo` en los servicios de MIA.
//
// Vive acá y no dentro de un módulo porque lo comparten el alta de agentes y la de
// usuarios internos, y las dos lo mandan al mismo servicio.

export const GENEROS = [
    { cod: "M", label: "Masculino" },
    { cod: "F", label: "Femenino" },
    { cod: "X", label: "No binario" },
];
